export default __webpack_public_path__ + "static/media/ar-308.418c16d1.svg";